import { DatePipe } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { WebStorage } from 'src/app/demo/components/auth/storage/web.storage';
import { ActivityTypeDTO } from 'src/app/demo/model/ActivityTypeDTO';
import { AttendanceDTO } from 'src/app/demo/model/AttendanceDTO';
import { MasterLookupDTO } from 'src/app/demo/model/MasterLookupDTO';
import { RoomDTO } from 'src/app/demo/model/RoomDTO';
import { StudentDTO } from 'src/app/demo/model/StudentDTO';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { Common } from 'src/app/demo/utils/common';
import { SentPhotoComponent } from '../../sent-photo/sent-photo.component';
import {
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { SupplyListComponent } from '../../../supply-list/supply-list.component';
import { OperationService } from 'src/app/demo/service/operation.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { StaffDTO } from 'src/app/demo/model/StaffDTO';
import * as moment from 'moment';
import { ActivityValidationsService } from 'src/app/demo/service/activity-validations.service';
import { GuardianDTO } from 'src/app/demo/model/GuardianDTO';
import { ActivityDTO } from 'src/app/demo/model/ActivityDTO';
import { profielBackgroundColor } from 'src/app/demo/sharing/constants/profielBackgroundColor';
import heic2any from 'heic2any';
function convertTo24Hour(timeStr: any) {
    if (!timeStr) return ""; // If value is null/undefined/empty, return an empty string

    const date = new Date(`1970-01-01 ${timeStr}`); // Convert string to Date object
    if (isNaN(date.getTime())) return ""; // If invalid date, return empty string

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
}
interface FileProgress {
    fileName: string;
    progress: number;
    imageUrl: any;
}
@Component({
    selector: 'app-record-activity',
    templateUrl: './record-activity.component.html',
    styleUrls: ['./record-activity.component.scss'],
})
export class RecordActivityComponent {
    @ViewChild('dropdownClassroom') dropdownClassroom: any;
    @ViewChild('fileInput') fileInput: ElementRef | undefined;
    activeTabIndex: number = 0;
    roomList: RoomDTO[] = [];
    userData: any;
    selectedRoom!: any | undefined;
    search: any = {};
    pageContext = {
        page: 0,
        previousPage: 0,
        itemsPerPage: 10,
        totalItems: 0,
        sort: 'name,asc',
    };
    attendanceList: AttendanceDTO[] = [];
    first: number = 0;
    last: number = 0;
    todaysDate: any = Common.momentTimeZoneDate(new Date());
    selectedStudents: AttendanceDTO[] = [];
    selectedStudentIds: (number | undefined)[] = [];
    studentIds: any[] = [];
    activityTypeList: ActivityTypeDTO[] = [];
    visibleMember: number | undefined;
    activityForm!: FormGroup;
    selectedActivityType: ActivityTypeDTO = {};
    mealTypeList: MasterLookupDTO[] = [];
    mealQuanityList: MasterLookupDTO[] = [];
    fileProgressList = new Map<string, FileProgress[]>();
    selectedImageFiles: File[] = [];
    documentsArray: any[] = [];
    moodTypeList: MasterLookupDTO[] = [];
    suppliesNeededTypeList: MasterLookupDTO[] = [];
    isSuppliesNeededLinkHovered = false;
    bathroomActivityTypeList: MasterLookupDTO[] = [];
    selectedType!: string;
    subTypeList: MasterLookupDTO[] = [];
    diaperSizeList: MasterLookupDTO[] = [];
    learningActivityList: MasterLookupDTO[] = [];
    learningCategoryList: MasterLookupDTO[] = [];
    faceActivityCheckList: MasterLookupDTO[] = [];
    isDisabled: boolean = false;
    submitButton: boolean = true;
    activityName: string = '';
    selectedActivityName!: string;
    loginStaff: StaffDTO = {};
    roomIds: (number | undefined)[] | undefined;
    selectAllStudents: boolean | undefined;
    curriculumTypeList: MasterLookupDTO[] = [];
    sortField: string = '';
    staffList: StaffDTO[] = [];
    adminStaffList: StaffDTO[] = [];
    studentSearchInput: any;
    actualStudList: AttendanceDTO[] = [];
    isVideoLoading: boolean = false;
    videoLoadError = false;
    openFromOverview: boolean = false;
    guardianList: GuardianDTO[] = [];
    staffApproval: boolean = false;
    isConvertingHeic: boolean = false;
    // Define custom error messages
    errorMessages: any = {
        required: 'This field is required',
        futureDate: 'Date cannot be in the future',
        min: 'Value must be greater than or equal to 0',
        maxFileSize: 'File size exceeds the allowed limit (Images: 20MB, Videos: 100MB)'
    };
    isAdminUserLogin: boolean = false;
    latestNapActivity: ActivityDTO = {};
    backgroundColors: string[] = [];
        // Store original form values for PHOTO activity rollback
        private originalFormValues: any = null;
    constructor(
        private lookupService: LookupService,
        private formBuilder: FormBuilder,
        private datePipe: DatePipe,
        private storage: WebStorage,
        public dialogService: DialogService,
        public ref: DynamicDialogRef,
        public supplyRef: DynamicDialogRef,
        public sentPhotoRef: DynamicDialogRef,
        private operationService: OperationService,
        private messageService: MessageService,
        public config: DynamicDialogConfig,
        private cdr: ChangeDetectorRef,
        private activityValidationsService: ActivityValidationsService,
        private confirmationService: ConfirmationService,

    ) {
        if (config.data.isFromRoom) {
            this.selectedRoom = this.config.data.roomId;
            this.openFromOverview = this.config.data.openFromOverview;
            this.selectedActivityType = this.openFromOverview == true ? this.config.data.selectedActivityType : {};
            this.activeTabIndex = this.config.data.activeTabIndex;
            this.selectedStudents = this.openFromOverview == true ? this.config.data.selectedStudents : [];
            setTimeout(() => {
                this.next();
            }, 200);
        }
        this.backgroundColors = profielBackgroundColor;
    }

    ngOnInit() {
        this.visibleMember = 0.5;
        this.submitButton = true;
        this.userData = this.storage.getUserData();
        this.isAdminUserLogin = Common.isAdminUserLogin(this.storage);
        this.pageContext.itemsPerPage = 10;
        this.selectedActivityName = 'ACTIVITY';
        this.activityForm = this.formBuilder.group({
            id: [undefined],
            date: [undefined, [Validators.required]],
            description: undefined,
            hasStaffOnly: [false],
            isDiaperCreamApplied: false,
            time: [
                convertTo24Hour(Common.momentTimeZoneTime(new Date())),
                [Validators.required],
            ],
            hasParentNotify: [false],
            activityRefValue1: [undefined],
            activityRefValue2: [''],
            activityRefValue3: [''],
            napReminder: [false],
            isNapTime: [false],
            activityTypeId: [],
            schoolId: this.userData.schoolId,
            staffId: [this.userData.refTableId, [Validators.required]],
            students: this.formBuilder.array([]),
            mileStones: this.formBuilder.array([]),
            status: 'A',
            photoUuid: undefined,
            activityStatus: 'Sent',
            isApprover: false,
            lastModified: [''],
            lastModifiedBy: [''],
            roomId: this.selectedRoom ? this.selectedRoom : undefined,
            activityNote: [''],
            acknowledgeBy: [''],
        });

        // Only validate when specific fields change
        const fieldsToWatch = ['activityRefValue1', 'activityRefValue2', 'activityRefValue3', 'description'];

        fieldsToWatch.forEach(field => {
            this.activityForm.get(field)?.valueChanges.subscribe(() => {
                if (this.activityForm.touched) {
                    this.validateField(field);
                }
            });
        });

        // Listen for activity type changes
        this.activityForm.get('activityRefValue1')?.valueChanges.subscribe(value => {
            // if (this.selectedActivityType.name === 'BATHROOM' && (value === 'Diaper' || value === 'Pee') ) {
            // // Set validation for diaper size
            // this.activityForm.get('activityRefValue3')?.setValidators([Validators.required]);
            // this.activityForm.get('activityRefValue3')?.updateValueAndValidity();
            // } else
            if (this.selectedActivityType.name === 'BATHROOM') {
                // Clear validation for diaper size
                this.activityForm.get('activityRefValue3')?.clearValidators();
                this.activityForm.get('activityRefValue3')?.updateValueAndValidity();
            }
        });

        if (this.userData.refTable == 'Staff') {
            this.lookupService
                .getStaffById(this.userData.refTableId)
                .subscribe((resp: HttpResponse<StaffDTO>) => {
                    let temp: StaffDTO = {};
                    this.loginStaff = resp.body ? resp.body : temp;
                    this.roomIds = this.loginStaff.rooms?.map(
                        (each) => each?.id
                    );
                    this.queryRoom();
                });
        } else {
            this.queryRoom();
        }
        this.viewPresentStaff();
    }
    fetchGuardians() {
        this.lookupService.queryGuardian({
            'status.equals': 'A',
            'schoolId.equals': this.userData.schoolId,
            'studentId.in': this.studentIds
        }).subscribe((res: HttpResponse<GuardianDTO[]>) => {
            this.guardianList = res.body ?? [];
        });
    }
    disableNap(activityTypeList: ActivityTypeDTO[]) {
        if (this.selectedStudents && this.selectedStudents.length > 0) {
            // Check nap status for all selected students
            const napStatuses: string[] = [];
            this.selectedStudents.forEach((student) => {
                let napStatus = 'Not Generated';
                if (student.latestNapActivity) {
                    if (student.latestNapActivity.activityNote?.includes('Nap Ended at:')) {
                        napStatus = 'Nap Ended';
                    } else {
                        napStatus = 'Nap Started';
                    }
                }
                napStatuses.push(napStatus);
            });

            // Check if all students have the same nap status
            const allSameStatus = napStatuses.every(status => status === napStatuses[0]);
            const commonStatus = napStatuses[0];

            activityTypeList.forEach((activity) => {
                if (activity.name === 'NAP START' || activity.name === 'NAP END') {
                    activity.disabled = false;
                    activity.isNapNotGenerated = false;
                    activity.isNapStart = false;
                    activity.isNapEnd = false;
                    activity.isMultipleStudent = false;

                    if (!allSameStatus) {
                        // Different nap statuses - disable both
                        activity.disabled = true;
                        activity.isMultipleStudent = true;
                    } else {
                        // All students have same status - apply normal logic
                        if (commonStatus === 'Not Generated' && activity.name === 'NAP END') {
                            activity.disabled = true;
                            activity.isNapNotGenerated = true;
                        } else if (commonStatus === 'Nap Started' && activity.name === 'NAP START') {
                            activity.disabled = true;
                            activity.isNapStart = true;
                        } else if (commonStatus === 'Nap Ended' && activity.name === 'NAP END') {
                            activity.disabled = true;
                            activity.isNapEnd = true;
                        }
                    }
                }
            });
        }

        return activityTypeList;
    }

    disableIncidentForMultipleStudents(activityTypeList: ActivityTypeDTO[]) {
        if (this.selectedStudents && this.selectedStudents.length > 1) {
            activityTypeList.forEach((activity) => {
                if (activity.name === 'INCIDENT') {
                    activity.disabled = true;
                    activity.isMultipleStudent = true;
                }
            });
        }
        return activityTypeList;
    }
    
    next() {
        this.activeTabIndex += 1;
        if (this.activeTabIndex == 1) {
            this.fetchActivityType();
        }
        if (this.activeTabIndex == 2) {
            this.activityForm.patchValue({
                date: this.todaysDate,
                time: convertTo24Hour(Common.momentTimeZoneTime(new Date())),
            });
            this.activityName = this.selectedActivityType.name;
            if (this.selectedActivityType.name == 'NAP') {
                this.activityForm.patchValue({
                    activityRefValue1: Common.momentTimeZoneTime(new Date())
                });
            } else if (this.selectedActivityType.name == 'INCIDENT' && (!Common.isAdminUserLogin(this.storage))) {
                this.activityForm.patchValue({
                    isApprover: true
                });
            } else if (this.selectedActivityType.name == 'NAP START' || this.selectedActivityType.name == 'NAP END') {
                this.activityForm.patchValue({
                    napReminder: true,
                    isNapTime: true
                });
            }
            if (this.selectedStudents != undefined) {
                const studentArray = this.activityForm.get(
                    'students'
                ) as FormArray;
                studentArray?.clear();

                if (Array.isArray(this.selectedStudents)) {
                    this.selectedStudents.forEach((attendance) => {
                        studentArray?.push(new FormControl({ ...attendance.student, roomId: attendance.roomId }));
                    });
                }

                if(this.selectedStudents.length == 1 && this.selectedStudents[0].latestNapActivity){
                    this.latestNapActivity = this.selectedStudents[0].latestNapActivity;
                    this.napTimeChange();
                }

            }

            this.lookupService
                .queryMasterLookups({
                    'schoolId.equals': this.userData.schoolId,
                    'type.equals': 'Meal Type',
                    'status.equals': 'A',
                    sort: 'name,asc',
                })
                .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                    let temp: MasterLookupDTO[] = [];
                    this.mealTypeList = res.body ? res.body : temp;
                });

            this.lookupService
                .queryMasterLookups({
                    'schoolId.equals': this.userData.schoolId,
                    'type.equals': 'Curriculum Type',
                    'status.equals': 'A',
                    sort: 'name,asc',
                })
                .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                    let temp: MasterLookupDTO[] = [];
                    this.curriculumTypeList = res.body ? res.body : temp;
                });

            this.lookupService
                .queryMasterLookups({
                    'schoolId.equals': this.userData.schoolId,
                    'type.equals': 'Meal Quantity',
                    'status.equals': 'A',
                    sort: 'name,asc',
                })
                .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                    let temp: MasterLookupDTO[] = [];
                    this.mealQuanityList = res.body ? res.body : temp;
                });

            this.lookupService
                .queryMasterLookups({
                    'schoolId.equals': this.userData.schoolId,
                    'type.equals': 'Mood Type',
                    'status.equals': 'A',
                    sort: 'name,asc',
                })
                .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                    let temp: MasterLookupDTO[] = [];
                    this.moodTypeList = res.body ? res.body : temp;
                });

            this.lookupService
                .queryMasterLookups({
                    'schoolId.equals': this.userData.schoolId,
                    'type.equals': 'Supply Needed',
                    'status.equals': 'A',
                    sort: 'name,asc',
                })
                .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                    let temp: MasterLookupDTO[] = [];
                    this.suppliesNeededTypeList = res.body ? res.body : temp;
                });

            this.lookupService
                .queryMasterLookups({
                    'schoolId.equals': this.userData.schoolId,
                    'type.equals': 'Bathroom activity Type',
                    'status.equals': 'A',
                    sort: 'name,asc',
                })
                .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                    let temp: MasterLookupDTO[] = [];
                    this.bathroomActivityTypeList = res.body ? res.body : temp;
                });

            this.lookupService
                .queryMasterLookups({
                    'schoolId.equals': this.userData.schoolId,
                    'type.equals': 'Diaper Size',
                    'status.equals': 'A',
                    sort: 'name,asc',
                })
                .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                    let temp: MasterLookupDTO[] = [];
                    this.diaperSizeList = res.body ? res.body : temp;
                });

            this.lookupService
                .queryMasterLookups({
                    'schoolId.equals': this.userData.schoolId,
                    'type.equals': 'Learning activity',
                    'status.equals': 'A',
                    sort: 'name,asc',
                })
                .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                    let temp: MasterLookupDTO[] = [];
                    this.learningActivityList = res.body ? res.body : temp;
                });

            this.lookupService
                .queryMasterLookups({
                    'schoolId.equals': this.userData.schoolId,
                    'type.equals': 'Learning Category',
                    'status.equals': 'A',
                    sort: 'name,asc',
                })
                .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                    let temp: MasterLookupDTO[] = [];
                    this.learningCategoryList = res.body ? res.body : temp;
                });

            this.lookupService
                .queryMasterLookups({
                    'schoolId.equals': this.userData.schoolId,
                    'type.equals': 'Face Activity Check',
                    'status.equals': 'A',
                    sort: 'name,asc',
                })
                .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                    let temp: MasterLookupDTO[] = [];
                    this.faceActivityCheckList = res.body ? res.body : temp;
                });


            this.selectedActivityType.name == 'INCIDENT' ? this.activityForm.get('activityRefValue2')?.setValue(true) : undefined;

            this.selectedActivityName =
                this.selectedActivityType.name != undefined
                    ? this.selectedActivityType.name + ' ACTIVITY'
                    : '';

            this.lookupService.queryStaff({ 'roomId.equals': this.selectedRoom, 'designation.notEquals': 'Kiosk' }).subscribe((res: HttpResponse<StaffDTO[]>) => {
                this.staffList = res.body ?? [];
            });

            this.validateForm();
        }

        this.activityForm.patchValue({
            hasStaffOnly:
                this.selectedActivityType.name == 'OBSERVATION' ||
                    this.selectedActivityType.name == 'NAME TO FACE'
                    ? true
                    : false,
        });

        this.isDisabled =
            this.selectedActivityType.name == 'OBSERVATION' ||
                this.selectedActivityType.name == 'NAME TO FACE'
                ? true
                : false;

        this.fetchGuardians();
    }
    selectedStaff!: StaffDTO;
    viewPresentStaff() {
        this.lookupService.getStaffById(this.activityForm.value.staffId).subscribe((res: HttpResponse<StaffDTO>) => {
            this.selectedStaff = res.body ? res.body : {};
        });
    }

    fetchActivityType() {
        const queryParams = {
            size: 30,
            sort: 'name,asc',
            page: 0,
            'status.equals': 'A',
            'schoolId.equals': this.userData.schoolId,
            'roomId.in': this.selectedRoom,
            'name.notIn': ['ABSENT', 'SIGN-OUT', 'SIGN-IN'],
        };
        this.lookupService
            .queryActivityTypeList(queryParams)
            .subscribe((resp: HttpResponse<ActivityTypeDTO[]>) => {
                let temp: ActivityTypeDTO[] = [];
                this.activityTypeList = this.disableNap(this.disableIncidentForMultipleStudents(resp.body ? resp.body : temp));
            });
    }

    getActivityIcon(activityName: string): string {
        const iconMap: { [key: string]: string } = {
            // 'Nap': 'wow wow-nap',
            'Nap Start': 'wow wow-nap',
            'Nap End': 'wow wow-nap',
            'Meal': 'wow wow-meal',
            'Learning': 'wow wow-learning',
            'Incident': 'wow wow-incident_activity',
            'Medication': 'wow wow-medication_activity',
            'Notes': 'wow wow-notes_activity',
            'Outdoor': 'wow wow-outdoor',
            'Photo': 'wow wow-video',
            'Bathroom': 'wow wow-bathroom',
            'Bottle': 'wow wow-bottle',
            'Observation': 'wow wow-observation',
        };

        const formattedActivity = activityName
            .toLowerCase()
            .replace(/\b\w/g, char => char.toUpperCase()); // Convert to title case

        return iconMap[formattedActivity] || 'wow-default'; // Fallback icon
    }

    fetchActivityTypeImg(activityType: ActivityTypeDTO) {
        if (activityType.logoFileUuid) {
            this.lookupService
                .queryDocumentByPhotoUid(activityType.logoFileUuid)
                .subscribe((response: HttpResponse<Blob>) => {
                    const body = response?.body;
                    if (body) {
                        const url = this.createImgFromBuffer(body);
                        activityType.imgUrl = url;
                    }
                });
        }
    }
    fetchAttendance() {
        delete this.search['id.in'];
        this.search.page = this.pageContext.page;
        this.search.sort = 'id,asc';
        this.search.size = 500;

        const { startUtc, endUtc } = Common.getUtcDayRange(this.todaysDate);
        this.search['date.greaterThanOrEqual'] = startUtc;
        this.search['date.lessThanOrEqual'] = endUtc;
        
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['roomId.equals'] = this.selectedRoom;
        this.search['status.equals'] = 'A';
        this.search['studentId.specified'] = true;
        this.search['hasSignIn.equals'] = true;

        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryAttendance(this.search)
            .subscribe((resp: HttpResponse<AttendanceDTO[]>) => {
                let temp: AttendanceDTO[] = [];
                this.attendanceList = resp.body ? resp.body : temp;
                this.actualStudList = this.attendanceList;
                this.pageContext.totalItems = Number(
                    resp.headers.get('X-Total-Count')
                );
      
                this.attendanceList.forEach((attendance: AttendanceDTO) => {
                    if(this.openFromOverview == true && attendance.studentId === this.selectedStudents[0].studentId){
                        this.latestNapActivity = attendance.latestNapActivity ?? {} as ActivityDTO;
                        this.napTimeChange();
                    }
                });

                this.last =
                    this.search.page != 0
                        ? this.last + this.attendanceList.length
                        : this.attendanceList.length;
                // this.selectedStudents = [];

                this.attendanceList.forEach((attendance: AttendanceDTO) => {
                    this.fetchStudent(attendance);
                });
            });
    }
    isInvalidTime = false;
    napTimeChange() {
        const latestNapActivityTime = convertTo24Hour(this.latestNapActivity.time);
        const napTime = this.activityForm.value.time;    
        if (this.selectedActivityType.name == 'NAP START' || this.selectedActivityType.name == 'NAP END') {
            if (latestNapActivityTime > napTime) {
                this.isInvalidTime = true;
            } else {
                this.isInvalidTime = false;
            }
        }
    }
    

    fetchStudent(attendance: AttendanceDTO) {
        if (attendance.studentId) {
            this.lookupService
                .getStudentById(attendance.studentId)
                .subscribe((resp: HttpResponse<StudentDTO>) => {
                    let temp: StudentDTO = {};
                    attendance.student = resp.body ? resp.body : temp;
                    this.fetchStudentImg(attendance.student);
                });
        }
    }
    fetchStudentImg(student: StudentDTO) {
        if (student.photoUuid) {
            this.lookupService
                .queryDocumentByPhotoUid(student.photoUuid)
                .subscribe((response: HttpResponse<Blob>) => {
                    const body = response?.body;
                    if (body) {
                        const url = this.createImgFromBuffer(body);
                        student.profileimg = url;
                    }
                });
        }
    }

    createImgFromBuffer(blob: Blob) {
        const url = URL.createObjectURL(blob);
        return url;
    }

    previous() {
        this.activeTabIndex -= 1;
        if (this.activeTabIndex == 0) {
            this.selectedActivityName = 'ACTIVITY';
        }
        if (this.activeTabIndex == 1) {
            this.fileProgressList.clear();
            this.selectedActivityName = 'ACTIVITY';
        }
    }

    valuess(event: any) {
    }

    // Validate a single field
    validateField(fieldName: string) {
        const control = this.activityForm.get(fieldName);
        if (!control) return;

        // Only validate the specific field based on activity type
        switch (this.selectedActivityType.name) {
            case 'MEAL':
                if (fieldName === 'activityRefValue1' || fieldName === 'activityRefValue2') {
                    control.setValidators([Validators.required]);
                }
                break;
            case 'BATHROOM':
                if (fieldName === 'activityRefValue1') {
                    control.setValidators([Validators.required]);
                }
                break;
            case 'NOTES':
                if (fieldName === 'description') {
                    control.setValidators([Validators.required]);
                }
                break;
            case 'INCIDENT':
                if (fieldName === 'description' || fieldName === 'activityRefValue2') {
                    control.setValidators([Validators.required]);
                }
                break;
            // Add other cases as needed
        }

        // Update only this field's validity
        control.updateValueAndValidity({ emitEvent: false });
    }

    // Validate entire form (used when saving)
    validateForm() {
        if (!this.activityForm || !this.selectedActivityType?.name) return;

        // Apply validations but prevent recursive updates
        this.activityValidationsService.applyValidations(this.activityForm, this.selectedActivityType.name);
        this.activityForm.updateValueAndValidity({ emitEvent: false });
        this.isSaveDisabled();
        this.cdr.detectChanges();
    }

    // Check if a field is required based on activity type
    isFieldRequired(fieldName: string): boolean {
        if (!this.selectedActivityType?.name) return false;

        // Common required fields for all activities
        if (fieldName === 'date' || fieldName === 'time') return true;

        switch (this.selectedActivityType.name) {
            case 'MEAL':
                return ['activityRefValue1', 'activityRefValue2', 'staffId'].includes(fieldName);
            case 'NAP START':
                return ['time', 'staffId'].includes(fieldName);
            case 'NAP END':
                return ['time', 'staffId'].includes(fieldName);
            case 'BATHROOM':
                return ['students', 'activityRefValue1', 'staffId'].includes(fieldName) ||
                    ((fieldName == 'activityRefValue2') && (this.activityForm?.get('activityRefValue1')?.value === 'Diaper' || this.activityForm?.get('activityRefValue1')?.value === 'Potty') || this.activityForm?.get('activityRefValue1')?.value === 'Pee');
            // return ['students', 'activityRefValue1','staffId'].includes(fieldName) ||
            //     ((fieldName == 'activityRefValue3' || fieldName == 'activityRefValue2') && this.activityForm?.get('activityRefValue1')?.value === 'Diaper' || this.activityForm?.get('activityRefValue1')?.value ==='Pee');
            case 'BOTTLE':
                return ['staffId'].includes(fieldName);
            case 'OUTDOOR':
                return ['staffId'].includes(fieldName);
            case 'MEDICATION':
            case 'NOTES':
            case 'OBSERVATION':
                return ['description', 'staffId'].includes(fieldName);
            case 'INCIDENT':
                return ['students', 'description', 'activityRefValue2', 'staffId'].includes(fieldName);
            case 'LEARNING':
                return ['students', 'activityRefValue1', 'activityRefValue2', 'staffId'].includes(fieldName);
            case 'PHOTO':
                return ['students', 'activityRefValue2', 'staffId'].includes(fieldName);
            default:
                return false;
        }
    }

    // Check if form is valid for save
    isSaveDisabled(): boolean {
        // Special case for activities that require students
        const requiresStudents = [
            'BATHROOM',
            'INCIDENT',
            'LEARNING',
            'PHOTO',
            'NAME TO FACE'
        ].includes(this.selectedActivityType.name || '');

        const studentsArray = this.activityForm.get('students')?.value || [];
        const hasStudents = studentsArray.length > 0;

        // If activity requires students but none are selected, form is invalid
        if (requiresStudents && !hasStudents) {
            return true;
        }

        // Special case for PHOTO activities that require at least one photo/video
        if (this.selectedActivityType.name === 'PHOTO') {
            const hasFiles = this.selectedImageFiles.length > 0 || this.documentsArray.length > 0;
            if (!hasFiles) {
                return true;
            }
        }

        // Check if form is valid and all required fields are filled
        return this.activityForm.invalid;
    }

    savee() {
        // Mark all form controls as touched to trigger validation
        this.markFormGroupTouched(this.activityForm);

        // Validate the form
        this.validateForm();

        if (this.activityForm.invalid) {
            // Log which controls are invalid
            Object.keys(this.activityForm.controls).forEach(key => {
                const control = this.activityForm.get(key);

            });
            return;
        }

        this.save();
    }


    save() {
        // Store original values for PHOTO activity rollback
            this.originalFormValues = {
                date: this.activityForm.get('date')?.value,
                time: this.activityForm.get('time')?.value
            };

        const timeControl = this.activityForm.get('time');
        if (timeControl) {
            let timeValue = timeControl.value; // Assume this is in 'HH:mm' or similar format
            // Parse and format time
            const formattedTime = moment(timeValue, 'HH:mm').format('hh:mm:ss A');
            timeControl.patchValue(formattedTime);
        }
        this.submitButton = false;
        this.patchDateValue('date');
        this.activityForm.patchValue({
            roomId: this.selectedRoom ? this.selectedRoom : undefined,
            activityTypeId: this.selectedActivityType
                ? this.selectedActivityType.id
                : undefined,
        });

        // Only send staffId for non-incident activities
        if (this.selectedActivityType.name === 'INCIDENT') {
            this.activityForm.patchValue({
                staffId: this.activityForm.value.staffId,
            });
        } else {
            this.activityForm.patchValue({
                staffId: this.userData.refTableId,
            });
        }
        // this.activityForm.value.activityStatus =
        //     this.activityForm.value.hasStaffOnly == true ? 'Approval' : 'Sent';
        this.activityForm.value.activityStatus =
            this.activityForm.value.isApprover == true ? 'Pending' : 'Sent';
        // For NAP START/END, always set isNapTime to true, and napReminder based on checkbox
        if (this.activityName == 'NAP START' || this.activityName == 'NAP END') {
            this.activityForm.patchValue({
                isNapTime: true
            });
        }
        // Add napReminder to payload
        this.activityForm.patchValue({
            napReminder: this.activityForm.get('napReminder')?.value
        });
        if (this.activityName == 'BATHROOM') {
            let activeNote: string = '';
            activeNote += this.activityForm.value.activityRefValue1
                ? this.activityForm.value.activityRefValue1
                : ' ';
            activeNote += this.activityForm.value.activityRefValue3
                ? ' (Size : ' + this.activityForm.value.activityRefValue3 + ')'
                : ' ';
            activeNote += this.activityForm.value.activityRefValue2
                ? ' ' + this.activityForm.value.activityRefValue2
                : ' ';
            activeNote += this.activityForm.value.description
                ? ' , ' + this.activityForm.value.description
                : ' ';
            this.activityForm.value.activityNote = activeNote;
        }
        else if (this.activityName == 'NAP START') {
            let activeNote: string = 'Nap Started at: ';
            const timeValue = this.activityForm.value.time;
            activeNote += moment(timeValue, 'hh:mm:ss A').format('hh:mm A');
            this.activityForm.value.activityNote = activeNote;
        } else if (this.activityName == 'NAP END') {
            const timeValue = this.activityForm.value.time;
            let activeNote: string = 'Nap Ended at: ';
            activeNote += moment(timeValue, 'hh:mm:ss A').format('hh:mm A');
            this.activityForm.value.activityNote = activeNote;
        }
        else if (this.activityName == 'NAP') {
            let activeNote: string = 'Slept from: ';
            activeNote += this.activityForm.value.activityRefValue1
                ? this.activityForm.value.activityRefValue1
                : ' ';
            activeNote += this.activityForm.value.activityRefValue2
                ? ' to ' + this.activityForm.value.activityRefValue2
                : ' ';
            activeNote += this.activityForm.value.description
                ? ' , ' + this.activityForm.value.description
                : ' ';
            this.activityForm.value.activityNote = activeNote;
        }
        else if (this.activityName == 'BOTTLE') {
            let activeNote: string = '';
            activeNote += this.activityForm.value.activityRefValue1
                ? this.activityForm.value.activityRefValue1 + ' OZ consumed'
                : ' ';

            activeNote += this.activityForm.value.description
                ? ' , ' + this.activityForm.value.description
                : ' ';
            this.activityForm.value.activityNote = activeNote;
        } else if (this.activityName == 'SUPPLIES NEEDED') {
            let activeNote: string = 'Supplies Needed: ';
            activeNote += this.activityForm.value.activityRefValue1
                ? this.activityForm.value.activityRefValue1
                : ' ';
            activeNote += this.activityForm.value.description
                ? ' , ' + this.activityForm.value.description
                : ' ';
            this.activityForm.value.activityNote = activeNote;
        } else if (this.activityName == 'SUPPLIES NEEDED') {
            let activeNote: string = 'Supplies Needed: ';
            activeNote += this.activityForm.value.activityRefValue1
                ? this.activityForm.value.activityRefValue1
                : ' ';
            activeNote += this.activityForm.value.description
                ? ' , ' + this.activityForm.value.description
                : ' ';
            this.activityForm.value.activityNote = activeNote;
        } else if (this.activityName == 'MEDICATION') {
            let activeNote: string = '';
            activeNote += this.activityForm.value.description
                ? '' + this.activityForm.value.description
                : ' ';
            this.activityForm.value.activityNote = activeNote;
        } else if (this.activityName == 'MOOD') {
            let activeNote: string = 'Mood: ';
            activeNote += this.activityForm.value.activityRefValue1
                ? this.activityForm.value.activityRefValue1
                : ' ';
            activeNote += this.activityForm.value.description
                ? ' , ' + this.activityForm.value.description
                : ' ';
            this.activityForm.value.activityNote = activeNote;
        } else if (this.activityName == 'PHOTO') {
            let activeNote: string = '';
            activeNote += this.activityForm.value.activityRefValue2
                ? ' ' + this.activityForm.value.activityRefValue2
                : ' ';
            this.activityForm.value.activityNote = activeNote;
        } else if (this.activityName == 'INCIDENT') {
            let activeNote: string = '';
            activeNote += this.activityForm.value.activityRefValue1
                ? 'Nature of the incident: ' +
                this.activityForm.value.activityRefValue1
                : ' ';
            activeNote += this.activityForm.value.activityRefValue2
                ? ' ' +
                ' , First Aid administered: ' +
                this.activityForm.value.activityRefValue2
                : ' ';
            activeNote += this.activityForm.value.activityRefValue3
                ? ' ' +
                ' , Additional Notes: ' +
                this.activityForm.value.activityRefValue3
                : ' ';
            this.activityForm.value.activityNote = activeNote;
            this.activityForm.value.activityStatus = Common.isAdminUserLogin(this.storage) ? 'Pending Acknowledgement' : 'Pending';
        } else if (this.activityName == 'NOTES' || this.activityName == 'OBSERVATION') {
            let activeNote: string = '';
            activeNote += this.activityForm.value.description
                ? '' + this.activityForm.value.description
                : ' ';
            this.activityForm.value.activityNote = activeNote;
        } else if (this.activityName == 'MEAL') {
            let activeNote: string = '';
            activeNote += this.activityForm.value.activityRefValue1
                ? this.activityForm.value.activityRefValue1 + ' Quantity: '
                : ' ';
            activeNote += this.activityForm.value.activityRefValue2
                ? this.activityForm.value.activityRefValue2
                : ' ';
            activeNote += this.activityForm.value.description
                ? ' , ' + this.activityForm.value.description
                : ' ';
            this.activityForm.value.activityNote = activeNote;
        }

        if (this.documentsArray && this.documentsArray.length > 0) {
            // Track created activity IDs per document for potential rollback and upload
            // activityIdsPerDoc[i] holds all activity IDs created for documentsArray[i]
            // (can be multiple when multi-classroom students are selected)
            const activityIdsPerDoc: number[][] = this.documentsArray.map(() => []);
            const allCreatedActivityIds: number[] = [];
            let uploadFailed = false;

            // Create activities first — one API call per photo/document
            const createActivitiesPromises = this.documentsArray.map((element, index) => {
                return new Promise<void>((resolve, reject) => {
                    this.activityForm.patchValue({
                        photoUuid: element.fileUuid,
                        activityStatus: this.activityForm.value.activityStatus,
                    });

                    const formValue = this.activityForm.value;
                    setTimeout(() => {
                        this.operationService.createActivity(formValue).subscribe(
                            (response: HttpResponse<any>) => {
                                if (response && response.body) {
                                    const body = response.body;
                                    if (Array.isArray(body)) {
                                        // Multi-student/multi-classroom: collect all returned IDs for this photo
                                        body.forEach((activity: any) => {
                                            if (activity && activity.id) {
                                                activityIdsPerDoc[index].push(activity.id);
                                                allCreatedActivityIds.push(activity.id);
                                            }
                                        });
                                    } else if (body.id) {
                                        // Single-student: single object with id
                                        activityIdsPerDoc[index].push(body.id);
                                        allCreatedActivityIds.push(body.id);
                                    }
                                    resolve();
                                } else {
                                    reject(new Error('Invalid API Response'));
                                }
                            },
                            (error) => {
                                reject(error);
                            }
                        );
                    }, 1000);
                });
            });

            // Wait for all activities to be created
            Promise.all(createActivitiesPromises).then(() => {
                // Upload each document to ALL activity IDs created for it
                // (handles single-student: 1 ID, and multi-classroom: multiple IDs per photo)
                const uploadPromises: Promise<void>[] = [];
                this.documentsArray.forEach((element, index) => {
                    activityIdsPerDoc[index].forEach((activityId) => {
                        const docCopy = { ...element }; // clone to avoid mutation across uploads
                        uploadPromises.push(
                            new Promise<void>((resolve, reject) => {
                                this.uploadDocuments(
                                    activityId,
                                    docCopy,
                                    this.selectedImageFiles[index],
                                    () => resolve(), // success
                                    () => {
                                        uploadFailed = true;
                                        reject(new Error(`Document upload failed for ${element.fileName}`));
                                    }
                                );
                            })
                        );
                    });
                });

                // Wait for all uploads to complete
                Promise.all(uploadPromises).then(() => {
                    if (!uploadFailed) {
                        this.ref.close({ status: '201' });
                        this.resetForm();
                    }
                }).catch((error) => {
                    // Document upload failed - rollback created activities
                    this.rollbackActivities(allCreatedActivityIds);
                    this.submitButton = true;
                    this.messageService.add({
                        severity: 'error',
                        life: 3000,
                        summary: 'Upload Failed',
                        detail: 'Activity created but document upload failed. Activity has been removed.',
                    });
                });
            }).catch((error) => {
                // Activity creation failed
                this.submitButton = true;
                this.messageService.add({
                    severity: 'error',
                    life: 3000,
                    summary: 'Save Error',
                    detail: 'There was an error creating the activity.',
                });
            });
        } else {
            // if (this.activityName == 'BATHROOM') {
            // }

            this.operationService
                .createActivity(this.activityForm.value)
                .subscribe(
                    (response: HttpResponse<any>) => {
                        // this.messageService.add({
                        //     severity: 'success',
                        //     life: 3000,
                        //     summary: 'Success',
                        //     detail: 'Activity Created successfully.',
                        // });
                        this.ref.close(response);
                        this.resetForm();
                    },
                    (error) => {
                        this.submitButton = true;
                        this.ref.close(error.error);
                        this.messageService.add({
                            severity: 'error',
                            life: 3000,
                            summary: 'Save Error',
                            detail: 'There was an error saving the form data.',
                        });
                    }
                );
        }
    }

    filter() {
        let filtered: AttendanceDTO[] = [];

        if (this.studentSearchInput.length !== 0) {
            for (let i = 0; i < this.attendanceList.length; i++) {
                let user = this.attendanceList[i];
                if (
                    user?.studentName &&
                    (user.studentName.toLowerCase().indexOf(this.studentSearchInput.toLowerCase()) === 0 ||
                        user.studentName.toLowerCase().includes(this.studentSearchInput.toLowerCase()))
                ) {
                    filtered.push(user);
                }
            }
        } else {
            filtered = [...this.actualStudList];
        }

        this.attendanceList = [...filtered];
        this.checkboxChanged();
    }

    filterRoom(event: any) {
        if (!this.config.data.isFromRoom) {
            let filter = event.filter;
            this.search = {};
            this.search.size = this.pageContext.itemsPerPage;
            this.search.page = this.pageContext.page;
            this.search.sort = 'name,asc';
            this.search['status.equals'] = 'A';
            this.search['name.contains'] = filter;
            this.search['id.in'] =
                !Common.isAdminUserLogin(this.storage)
                    ? this.roomIds
                    : undefined;
            Common.removeEmptyFields(this.search);
            this.lookupService
                .queryRooms(this.search)
                .subscribe((res: HttpResponse<RoomDTO[]>) => {
                    let temp: RoomDTO[] = [];
                    this.roomList = res.body ? res.body : temp;
                });
            this.search = {};
        }
    }

    queryRoom() {
        // this.search.size = ITEMS_PER_PAGE;
        this.search.page = this.pageContext.page;
        this.search.sort = 'name,asc';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['status.equals'] = 'A';

        if (this.config.data.isFromRoom) {
            this.roomIds = [Number(this.config.data.roomId)];
            this.search['id.in'] = this.roomIds;
        } else {
            this.search['id.in'] =
                !Common.isAdminUserLogin(this.storage)
                    ? this.roomIds
                    : undefined;
        }

        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryRooms(this.search)
            .subscribe((res: HttpResponse<RoomDTO[]>) => {
                let temp: RoomDTO[] = [];
                this.roomList = res.body ? res.body : temp;
                this.selectedRoom = this.roomList
                    ? Common.isAdminUserLogin(this.storage)
                        ? this.loginStaff.primaryRoomId
                        : !Common.isAdminUserLogin(this.storage)
                            ? this.loginStaff?.primaryRoomId
                            : undefined
                    : undefined;
                if (this.config.data.isFromRoom) {
                    this.selectedRoom = this.roomList[0].id;
                }
                this.fetchAttendance();
            });
    }



    loadStudent(event: any) {
        if (event.first > event.rows) {
            this.pageContext.page = event.first / event.rows;
        } else if (event.first == event.rows) {
            this.pageContext.page = event.first / event.rows;
        } else {
            this.pageContext.page = 0;
        }
        this.first = event.first;
        this.search = {};
        this.last = this.pageContext.page * event.rows;
        const sortOd = event.sortOrder == 1 ? 'asc' : 'desc';
        const sortFld = event.sortField != undefined ? event.sortField : 'id';
        this.pageContext.sort = `${sortFld},${sortOd}`;
        this.pageContext.itemsPerPage = event.rows;
        this.fetchAttendance();
    }

    toggleAllSelection() {
        this.attendanceList.forEach(
            (attendance) => (attendance.selected = this.selectAllStudents)
        );

        if (this.selectAllStudents) {
            this.selectedStudents = [...this.attendanceList];
        } else {
            this.selectedStudents = [];
        }
        this.selectedStudentIds = this.selectedStudents.map(
            (selected) => selected.id
        );
        this.studentIds = this.selectedStudents.map(
            (std) => std.studentId
        );
    }


    toggleSelection(student: any) {
        const index = this.selectedStudents.findIndex(
            (selected) => selected.id === student.id
        );
        if (index !== -1) {
            this.selectedStudents.splice(index, 1);
        } else {
            this.selectedStudents.push(student);
        }
        this.selectedStudentIds = this.selectedStudents.map(
            (selected) => selected.id
        );
        this.studentIds = this.selectedStudents.map(
            (std) => std.studentId
        );
    }

    isSelected(attendance: AttendanceDTO): boolean {
        return this.selectedStudents.includes(attendance);
    }


    checkboxChanged() {
        if (this.attendanceList && this.attendanceList?.length !== 0) {
            if (this.isAllSelected()) this.selectAllStudents = true;
            else this.selectAllStudents = false;
        } else {
            this.selectAllStudents = false;
        }
    }

    isAllSelected(): boolean {
        return this.attendanceList.every((student) => student.selected);
    }


    filterMealType(event: any) {
        let filter = event.filter;
        this.search = {};
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = 'name,asc';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['type.equals'] = 'Meal Type';
        this.search['name.contains'] = filter;
        this.search['status.equals'] = 'A';
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryMasterLookups(this.search)
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.mealTypeList = res.body ? res.body : temp;
            });
        this.search = {};
    }

    filterCurriculumType(event: any) {
        let filter = event.filter;
        this.search = {};
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = 'name,asc';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['type.equals'] = 'Curriculum Type';
        this.search['name.contains'] = filter;
        this.search['status.equals'] = 'A';
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryMasterLookups(this.search)
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.curriculumTypeList = res.body ? res.body : temp;
            });
        this.search = {};
    }

    filterMealQuantity(event: any) {
        let filter = event.filter;
        this.search = {};
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = 'name,asc';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['type.equals'] = 'Meal Quantity';
        this.search['name.contains'] = filter;
        this.search['status.equals'] = 'A';
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryMasterLookups(this.search)
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.mealQuanityList = res.body ? res.body : temp;
            });
        this.search = {};
    }

    // onFileSelect(event: any) {
    //     if (event.target.files && event.target.files.length > 0) {
    //         const selectedFiles = Array.from(event.target.files) as File[];
    //         const newDocuments: any[] = [];
    //         selectedFiles.forEach((file: any) => {
    //             let file_extension = file.name.split('.').pop();
    //             let document = {
    //                 id: undefined,
    //                 docType: 'ACTIVITY',
    //                 docStatus: 'Activity',
    //                 fileName: file.name,
    //                 contentType: file_extension,
    //                 fileUuid: undefined,
    //                 folderUuid: undefined,
    //                 refTable: 'Activity',
    //                 refTableId: undefined,
    //                 schoolId: this.userData.schoolId,
    //                 status: 'A',
    //                 lastModified: undefined,
    //                 lastModifiedBy: undefined,
    //                 expiryDate: undefined,
    //             };

    //             newDocuments.push(document);

    //             const reader = new FileReader();
    //             let progress: number;
    //             reader.onprogress = (e) => {
    //                 if (e.lengthComputable) {
    //                     progress = (e.loaded / e.total) * 100;
    //                     this.fileProgressList.set(file.name, [
    //                         {
    //                             fileName: file.name,
    //                             progress: progress,
    //                             imageUrl: undefined,
    //                         },
    //                     ]);

    //                 }
    //             };

    //             reader.onload = (e) => {
    //                 const imageUrl = e?.target?.result;
    //                 this.fileProgressList.set(file.name, [
    //                     {
    //                         fileName: file.name,
    //                         progress: progress,
    //                         imageUrl: imageUrl,
    //                     },
    //                 ]);
    //             };

    //             reader.readAsDataURL(file);
    //         });

    //         this.selectedImageFiles =
    //             this.selectedImageFiles.concat(selectedFiles);
    //         this.documentsArray = this.documentsArray.concat(newDocuments);
    //     }
    // }

    onFileSelect(event: any) {
        const input = event?.target || event?.originalEvent?.target;
        if (!input || !input.files || input.files.length === 0) {
            return;
        }

    const multiFileActivityNames = ['PHOTO', 'LEARNING', 'NOTES', 'OUTDOOR','INCIDENT'];
    const isMultiFileActivity = multiFileActivityNames.includes(this.selectedActivityType?.name || '');

    if (!isMultiFileActivity) {
            // Single-file behavior for non-PHOTO activities (preserve existing behavior)
            const file: File = input.files[0];
            const file_extension = file.name.split('.').pop();

            const document = {
                id: undefined,
                docType: 'ACTIVITY',
                docStatus: 'Activity',
                fileName: file.name,
                contentType: file_extension,
                fileUuid: undefined,
                folderUuid: undefined,
                refTable: 'Activity',
                refTableId: undefined,
                schoolId: this.userData.schoolId,
                status: 'A',
                lastModified: undefined,
                lastModifiedBy: undefined,
                expiryDate: undefined,
            };

            // Replace previous selections
            this.selectedImageFiles = [file];
            this.documentsArray = [document];
            this.fileProgressList.clear(); // Clear preview list

            if (!this.activityValidationsService.validateFileSize(file)) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'File Size Error',
                    detail: `File "${file.name}" exceeds the size limit (${file.type.startsWith('video/') ? '100MB for videos' : '20MB for images'}).`,
                    life: 5000
                });
                return;
            }

            const reader = new FileReader();
            let progress: number;

            reader.onprogress = (e) => {
                if (e.lengthComputable) {
                    progress = (e.loaded / e.total) * 100;
                    this.fileProgressList.set(file.name, [
                        {
                            fileName: file.name,
                            progress: progress,
                            imageUrl: undefined,
                        },
                    ]);
                }
            };

            reader.onload = (e) => {
                const imageUrl = e?.target?.result;
                this.fileProgressList.set(file.name, [
                    {
                        fileName: file.name,
                        progress: progress,
                        imageUrl: imageUrl,
                    },
                ]);
            };

            reader.readAsDataURL(file);

            // Trigger validation update after file selection
            this.validateForm();
            this.cdr.detectChanges();
            return;
        }

        // PHOTO activity: allow multiple files
        const files: File[] = Array.from(input.files);

        // Process files with async validation
        const processFiles = async () => {

            for (const originalFile of files) {
                // Check if file is HEIC and convert if needed
                let file = originalFile;
                const isHeic = originalFile.name.toLowerCase().endsWith('.heic') || originalFile.name.toLowerCase().endsWith('.heif') || originalFile.type === 'image/heic' || originalFile.type === 'image/heif';

                if (isHeic) {
                    try {
                        file = await this.convertHeicToJpeg(originalFile);
                    } catch (error) {
                        console.error('DEBUG: HEIC conversion failed, skipping file', error);
                        this.messageService.add({
                            severity: 'error',
                            summary: 'File Conversion Error',
                            detail: `Unable to convert HEIC file "${originalFile.name}". Please try a different image format.`,
                            life: 5000
                        });
                        continue; // skip this file
                    }
                }

                const file_extension = file.name.split('.').pop();

                const document = {
                    id: undefined,
                    docType: 'ACTIVITY',
                    docStatus: 'Activity',
                    fileName: file.name,
                    contentType: file_extension,
                    fileUuid: undefined,
                    folderUuid: undefined,
                    refTable: 'Activity',
                    refTableId: undefined,
                    schoolId: this.userData.schoolId,
                    status: 'A',
                    lastModified: undefined,
                    lastModifiedBy: undefined,
                    expiryDate: undefined,
                };


                
                // Check video duration if it's a video
                if (file.type.startsWith('video/')) {
                    // Check file size
                    if (!this.activityValidationsService.validateFileSize(file)) {
                    this.messageService.add({
                    severity: 'error',
                    summary: 'File Size Error',
                    detail: `File "${file.name}" exceeds the size limit (${file.type.startsWith('video/') ? '100MB for videos' : '20MB for images'}).`,
                    life: 5000
                    });
                    continue; // skip this file
                    }

                    const isValidDuration = await this.activityValidationsService.validateVideoDuration(file);
                    if (!isValidDuration) {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Video Duration Error',
                            detail: `Video "${file.name}" exceeds 1 minute duration limit.`,
                            life: 5000
                        });
                        continue; // skip this file
                    }
                }



                this.selectedImageFiles = this.selectedImageFiles.concat(file);
                this.documentsArray = this.documentsArray.concat(document);

                this.fileProgressList.set(file.name, [
                    {
                        fileName: file.name,
                        progress: 0,
                        imageUrl: undefined,
                    },
                ]);

                const reader = new FileReader();
                let progress = 0;

                reader.onprogress = (e) => {
                    if (e.lengthComputable) {
                        progress = (e.loaded / e.total) * 100;
                        this.fileProgressList.set(file.name, [
                            {
                                fileName: file.name,
                                progress: progress,
                                imageUrl: undefined,
                            },
                        ]);
                    }
                };

                reader.onload = (e) => {
                    const imageUrl = e?.target?.result;
                    this.fileProgressList.set(file.name, [
                        {
                            fileName: file.name,
                            progress: progress,
                            imageUrl: imageUrl,
                        },
                    ]);
                };

                reader.readAsDataURL(file);
            }
        };

        processFiles().then(() => {
            // Trigger validation update after file selection
            this.validateForm();
            this.cdr.detectChanges();
        });
    }

    open() {
        this.sentPhotoRef = this.dialogService.open(SentPhotoComponent, {
            header: 'Choose Photo',
            width: '60%',
            contentStyle: { overflow: 'auto' },
            baseZIndex: 10000,
            maximizable: true,
        });
        this.sentPhotoRef.onClose.subscribe((res: any) => {

            res?.forEach((value: any, key: string) => {

                this.selectedImageFiles = this.selectedImageFiles.concat(
                    value.selectFile
                );
                this.documentsArray = this.documentsArray.concat(
                    value.documentObj
                );

                this.fileProgressList.set(value.documentObj.fileName, [
                    {
                        fileName: value.documentObj.fileName,
                        progress: 100,
                        imageUrl: undefined,
                    },
                ]);

            });

            // Trigger validation update after adding files from dialog
            this.validateForm();
            this.cdr.detectChanges();
        });
    }

    filterMoodType(event: any) {
        let filter = event.filter;
        this.search = {};
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = 'name,asc';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['type.equals'] = 'Mood Type';
        this.search['name.contains'] = filter;
        this.search['status.equals'] = 'A';
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryMasterLookups(this.search)
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.moodTypeList = res.body ? res.body : temp;
            });
        this.search = {};
    }

    onItemSetting(header: string) {
        let tempData: any = {};
        this.supplyRef = this.dialogService.open(SupplyListComponent, {
            data: tempData,
            header: header,
            width: '50%',
            contentStyle: { overflow: 'auto' },
            baseZIndex: 10000,
        });
        this.supplyRef.onClose.subscribe(() => {
            this.lookupService
                .queryMasterLookups({
                    'schoolId.equals': this.userData.schoolId,
                    'type.equals': 'Supply Needed',
                    'status.equals': 'A',
                    sort: 'name,asc',
                })
                .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                    let temp: MasterLookupDTO[] = [];
                    this.suppliesNeededTypeList = res.body ? res.body : temp;
                });
        });
    }

    filterBathroomActivityType(event: any) {
        let filter = event.filter;
        this.search = {};
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = 'name,asc';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['type.equals'] = 'Bathroom activity Type';
        this.search['name.contains'] = filter;
        this.search['status.equals'] = 'A';
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryMasterLookups(this.search)
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.bathroomActivityTypeList = res.body ? res.body : temp;
            });
        this.search = {};
    }

    changeSubType() {
        this.search = {};
        if (this.activityForm.get('activityRefValue1')!.value == 'Potty') {
            this.activityForm.patchValue({
                activityRefValue3: undefined,
                isDiaperCreamApplied: false,
            });
        }
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = 'name,asc';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['type.equals'] = this.selectedType;
        this.search['status.equals'] = 'A';
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryMasterLookups(this.search)
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.subTypeList = res.body ? res.body : temp;
            });
        this.search = {};
    }

    filterDiaperSize(event: any) {
        let filter = event.filter;
        this.search = {};
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = 'name,asc';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['type.equals'] = 'Diaper Size';
        this.search['name.contains'] = filter;
        this.search['status.equals'] = 'A';
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryMasterLookups(this.search)
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.diaperSizeList = res.body ? res.body : temp;
            });
        this.search = {};
    }

    filterLearningActivity(event: any) {
        let filter = event.filter;
        this.search = {};
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = 'name,asc';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['type.equals'] = 'Learning activity';
        this.search['name.contains'] = filter;
        this.search['status.equals'] = 'A';
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryMasterLookups(this.search)
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.learningActivityList = res.body ? res.body : temp;
            });
        this.search = {};
    }

    filterLearningCategory(event: any) {
        let filter = event.filter;
        this.search = {};
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = 'name,asc';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['type.equals'] = 'Face Activity Check';
        this.search['name.contains'] = filter;
        this.search['status.equals'] = 'A';
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryMasterLookups(this.search)
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.faceActivityCheckList = res.body ? res.body : temp;
            });
        this.search = {};
    }

    filterFaceActivityCheck(event: any) {
        let filter = event.filter;
        this.search = {};
        this.search.size = this.pageContext.itemsPerPage;
        this.search.page = this.pageContext.page;
        this.search.sort = 'naem,asc';
        this.search['schoolId.equals'] = this.userData.schoolId;
        this.search['type.equals'] = 'Face Activity Check';
        this.search['name.contains'] = filter;
        this.search['status.equals'] = 'A';
        Common.removeEmptyFields(this.search);
        this.lookupService
            .queryMasterLookups(this.search)
            .subscribe((res: HttpResponse<MasterLookupDTO[]>) => {
                let temp: MasterLookupDTO[] = [];
                this.learningCategoryList = res.body ? res.body : temp;
            });
        this.search = {};
    }



    // removeFile(file: any) {
    //     this.selectedImageFiles = this.selectedImageFiles.filter(
    //         (element) => element.name !== file.key
    //     );
    //     this.fileProgressList.delete(file.key);
    //     this.documentsArray = this.documentsArray.filter(
    //         (document) => document.fileName != file.key
    //     );
    // }

    onRemoveStud(event: Event,i:any, stud: any) {        
        this.confirmationService.confirm({
            key: 'confirm22',
            target: event.target as EventTarget,
            message: `Do you want to Remove ${stud.fullName}?`,
            acceptButtonStyleClass:'p-button-primary p-button-raised',
            rejectButtonStyleClass: 'p-button-secondary p-button-outlined', 
            defaultFocus: 'none',
            accept: () => this.removeStudent(i,stud),
            reject: () => {},
        });
    }

    removeStudent(index: number, student: any) {
        const studentsArray = this.activityForm.get('students') as FormArray;
        studentsArray.removeAt(index);
        this.selectedStudents.splice(index, 1);
        const studentIndex = this.attendanceList.findIndex(
            (attendance: AttendanceDTO) => attendance.student?.id == student.id
        );
        if (studentIndex > -1) {
            this.attendanceList[studentIndex].selected = false;

        }
        this.attendanceList = [...this.attendanceList]
        this.checkboxChanged();
        this.cdr.detectChanges();
    }

    removeFile(file: any) {
        this.selectedImageFiles = this.selectedImageFiles.filter(
            (element) => element.name !== file.key
        );
        this.fileProgressList.delete(file.key);
        this.documentsArray = this.documentsArray.filter(
            (document) => document.fileName !== file.key
        );

        // Reset file input so same file can be re-uploaded
        if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
        }

        // Trigger validation update after file removal
        this.validateForm();
        this.cdr.detectChanges();
    }



    resetForm() {
        this.activityForm = this.formBuilder.group({
            id: [undefined],
            date: [Common.momentTimeZoneDate(new Date())],
            description: undefined,
            hasStaffOnly: [false],
            isDiaperCreamApplied: false,
            time: [
                convertTo24Hour(Common.momentTimeZoneTime(new Date())),
                [Validators.required],
            ],
            hasParentNotify: [false],
            activityRefValue1: [undefined],
            activityRefValue2: [''],
            activityRefValue3: [''],
            napReminder: [false],
            isNapTime: [false],
            activityTypeId: [],
            schoolId: this.userData.schoolId,
            staffId: [undefined],
            students: this.formBuilder.array([]),
            mileStones: this.formBuilder.array([]),
            status: ['A'],
            photoUuid: undefined,
            activityStatus: 'Approval',
            lastModified: [''],
            lastModifiedBy: [''],
            roomId: undefined,
        });
        this.ref.close();
    }

    uploadDocuments(savedObjId: any, document: any, file: any, onSuccess?: () => void, onError?: () => void) {
        document.refTableId = savedObjId;

        this.operationService.createDocument(file, document).subscribe(
            (documentResponse: any) => {
                this.submitButton = false;
                if (onSuccess) {
                    onSuccess();
                } else {
                    this.handleSuccessAndClose(documentResponse);
                }
            },
            () => {
                this.submitButton = true;
                if (onError) {
                    onError();
                } else {
                    this.resetForm();
                    this.messageService.add({
                        severity: 'error',
                        life: 3000,
                        summary: 'Document Upload Error',
                        detail: 'There was an error uploading the document.',
                    });
                }
            }
        );
    }

    // Rollback created activities if document upload fails
    rollbackActivities(activityIds: number[]) {
        const deletePromises = activityIds.map(id =>
            new Promise<void>((resolve) => {
                const activityToDelete: ActivityDTO = { id: id };
                this.operationService.deleteActivity(activityToDelete).subscribe(
                    () => resolve(),
                    () => resolve() // Continue even if delete fails
                );
            })
        );

        Promise.all(deletePromises).then(() => {
            console.log('Successfully rolled back created activities');

            // Restore original form values for PHOTO activity
            if (this.originalFormValues) {
                this.activityForm.patchValue({
                    date: this.originalFormValues.date,
                    time: this.originalFormValues.time
                });
                this.originalFormValues = null; // Clear stored values
            }
        });
    }

    handleSuccessAndClose(documentResponse: any) {
        if (!this.config.data.isFromRoom) {
            this.messageService.add({
                severity: 'success',
                life: 3000,
                summary: 'Success',
                detail: 'Document Created successfully.',
            });
        }
        this.resetForm();
        this.ref.close(documentResponse);
    }

    cancel() {
        if (this.activeTabIndex == 0) {
            this.ref.close();
        }
        if (this.activeTabIndex == 1) {
            this.ref.close();
        }
        if (this.activeTabIndex == 2 && this.documentsArray.length > 0) {
            let temp: any = {
                documentsArray: this.documentsArray,
                selectedImageFiles: this.fileProgressList,
                files: this.selectedImageFiles,
            };
            this.ref.close(temp);
        } else if (this.activeTabIndex == 2) {
            this.ref.close();
        }
    }


    private patchDateValue(controlName: string): void {
        const dateValue = this.activityForm.get(controlName)?.value;

        // Check if the value is a valid date before formatting
        if (dateValue && !isNaN(new Date(dateValue).getTime())) {
            this.activityForm.patchValue({
                [controlName]: Common.convertLocalDateToUTC(dateValue)
            });
        } else {
            // If the value is not a valid date, set it to null or handle it accordingly
            this.activityForm.patchValue({
                [controlName]: null,
            });
        }
    }


    onVideoLoadStart() {
        this.isVideoLoading = true;
        this.videoLoadError = false;
    }

    onVideoCanPlay() {
        this.isVideoLoading = false;
        this.videoLoadError = false;
    }

    onVideoWaiting() {
        this.isVideoLoading = true;
    }

    onVideoError(event: Event) {
        console.error('Video load error', event);
        this.isVideoLoading = false;
        this.videoLoadError = true;
    }

    // Optional: Add a method to retry video loading
    retryVideoLoad() {
        this.videoLoadError = false;
        // You might want to force a reload or refresh the video source
    }

    getFileType(fileName: string): string {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'svg', 'heic', 'heif', 'tiff', 'bmp', 'webp'];
        const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'm4v', 'hevc','avi', 'webm'];

        const extension = fileName.split('.').pop()?.toLowerCase();

        if (extension && imageExtensions.includes(extension)) {
            return 'image';
        } else if (extension && videoExtensions.includes(extension)) {
            return 'video';
        }
        return 'other';
    }
    clearAll() {
        this.studentSearchInput = "";
        this.selectedRoom = undefined;
        this.todaysDate = Common.momentTimeZoneDate(new Date());
        this.actualStudList = [];
        this.selectedStudents = [];
        this.selectedStudentIds = [];
        this.selectAllStudents = false;
        this.studentIds = [];
        this.queryRoom();
    }






    // Set activity type
    setActivityType(activityType: string): void {
        this.selectedActivityType.name = activityType;
        this.selectedActivityName = activityType;

        // Reset form values except for common fields
        const date = this.activityForm.get('date')?.value;
        const time = this.activityForm.get('time')?.value;
        const staffId = this.activityForm.get('staffId')?.value;

        this.activityForm.reset({
            date: date,
            time: time,
            staffId: staffId,
            schoolId: this.userData.schoolId,
            status: 'A',
            activityStatus: 'Sent',
            isApprover: false
        });

        // Apply validations based on activity type
        this.activityValidationsService.applyValidations(this.activityForm, activityType);

        // Force form validation update
        this.activityForm.updateValueAndValidity();

    }



    // Helper to mark all form controls as touched
    markFormGroupTouched(formGroup: FormGroup): void {
        Object.values(formGroup.controls).forEach(control => {
            control.markAsTouched();

            if (control instanceof FormGroup) {
                this.markFormGroupTouched(control);
            }
        });
    }

    // Helper to check if a control is invalid and touched
    isInvalidAndTouched(controlName: string): boolean {
        const control = this.activityForm.get(controlName);
        return control ? control.invalid && control.touched : false;
    }

    // Helper to get control error message
    getErrorMessage(controlName: string): string {
        const control = this.activityForm.get(controlName);
        if (!control || !control.errors) return '';

        // Return the first error message
        const firstError = Object.keys(control.errors)[0];
        return this.errorMessages[firstError] || 'Invalid input';
    }

    // Helper to get a friendly field name for display
    getFieldDisplayName(controlName: string): string {
        const fieldNames: any = {
            'date': 'Date',
            'time': 'Time',
            'staffId': 'Staff Present',
            'description': this.selectedActivityType.name === 'INCIDENT' ? 'What happened' : 'Description',
            'activityRefValue1': this.getActivityRefValue1Name(),
            'activityRefValue2': this.getActivityRefValue2Name(),
            'activityRefValue3': this.selectedActivityType.name === 'BATHROOM' ? 'Diaper Size' : 'Additional Notes',
            'students': 'Students'
        };

        return fieldNames[controlName] || controlName;
    }

    // Get display name for activityRefValue1 based on activity type
    private getActivityRefValue1Name(): string {
        const names: any = {
            'MEAL': 'Meal Type',
            'NAP': 'Start Time',
            'BATHROOM': 'Bathroom Type',
            'BOTTLE': 'Amount (OZ)',
            'MOOD': 'Mood',
            'SUPPLIES': 'Supplies Needed',
            'CURRICULUM': 'Type',
            'LEARNING': 'Activity Name',
            'NAME TO FACE': 'Check Type'
        };

        return names[this.selectedActivityType.name] || 'Activity Reference Value';
    }

    // Get display name for activityRefValue2 based on activity type
    private getActivityRefValue2Name(): string {
        const names: any = {
            'MEAL': 'Quantity',
            'NAP': 'End Time',
            'BATHROOM': 'Sub Type',
            'INCIDENT': 'First Aid Administered',
            'LEARNING': 'Categories',
            'PHOTO': 'Remarks'
        };

        return names[this.selectedActivityType.name] || 'Activity Reference Value';
    }
    selectedParent!: GuardianDTO;
    viewParentAcknowledgement() {
        this.lookupService.getGuardianById(this.activityForm.value.acknowledgeBy).subscribe((res: HttpResponse<GuardianDTO>) => {
            this.selectedParent = res.body ? res.body : {};
        });
    }

    getActivityTooltip(activityType: any): string {
        if (activityType.isMultipleStudent) {
            // Check if it's an incident activity with multiple students
            if (activityType.name === 'INCIDENT') {
                return 'Incident activities cannot be recorded for multiple students at once.';
            }
            return "Selected students have different nap statuses.";
        } else if (activityType.isNapNotGenerated) {
            return "Nap is not started.";
        } else if (activityType.isNapStart) {
            return "Nap is already started.";
        } else if (activityType.isNapEnd) {
            return "Nap is already ended.";
        }
        return '';
    }




    getInitials(fullName?: string): string {
        if (!fullName?.trim()) return '';
        const words = fullName.trim().split(/[-\s]+/);
        const firstLetter = words[0]?.[0]?.toUpperCase() || '';
        const secondLetter = words[1]?.[0]?.toUpperCase() || '';
        return `${firstLetter}${secondLetter}`.trim();
    }

    getBackgroundColor(id: any) {
        if (!id) return this.backgroundColors[0];
        const index = (id - 1) % this.backgroundColors.length;
        return this.backgroundColors[index];
    }

    // Convert HEIC files to JPEG for browser compatibility
    private async convertHeicToJpeg(file: File): Promise<File> {
        this.isConvertingHeic = true;
        this.messageService.add({
            severity: 'info',
            summary: 'Converting Image',
            detail: `Converting ${file.name} from HEIC to JPEG format...`,
            life: 5000
        });

        try {
            const convertedBlob = await heic2any({
                blob: file,
                toType: 'image/jpeg',
                quality: 0.8
            }) as Blob;

            // Create new file with JPEG extension
            const newFileName = file.name.replace(/\.(heic|heif)$/i, '.jpg');
            const convertedFile = new File([convertedBlob], newFileName, {
                type: 'image/jpeg',
                lastModified: Date.now()
            });

            this.isConvertingHeic = false;
            this.messageService.add({
                severity: 'success',
                summary: 'Conversion Complete',
                detail: `${file.name} has been converted to JPEG format.`,
                life: 2000
            });
            return convertedFile;
        } catch (error) {
            console.error('DEBUG: HEIC conversion failed', error);
            this.isConvertingHeic = false;
            throw error;
        }
    }

}
